import React from 'react';
import { FaUsers, FaRegUserCircle } from 'react-icons/fa';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { lazyPage } from '../lazyPage';

const Users = lazyPage(() => import(/* webpackChunkName: "m-people" */ '../../pages/Users'), (m) => m.Users);
const UserManagement = lazyPage(() => import(/* webpackChunkName: "m-people" */ '../../pages/UserManagement'));
const PeopleDirectoryPage = lazyPage(() => import(/* webpackChunkName: "m-people" */ './pages/PeopleDirectoryPage'));
const PersonDetailPage = lazyPage(() => import(/* webpackChunkName: "m-people" */ './pages/PersonDetailPage'));

/**
 * People module manifests. The DIRECTORY (§2a resolver view over the five person
 * stores) is the module home; the legacy lists stay as children at their URLs
 * (strangler — usage decides their future, per the consolidation plan rules).
 *
 * The directory is gated by `people_mgmt` — a key that does not exist in the
 * permission store yet, so scoped users see no change while null-permission
 * admins get it (the insights_mgmt pattern; flagged in the wave report).
 */
const peopleManifests = [
    {
        id: 'people-directory',
        featureName: 'people_mgmt',
        permission: 'view',
        routes: [
            { path: '/people', element: <PeopleDirectoryPage /> },
            { path: '/people/person', element: <PersonDetailPage /> },
        ],
        sidebarItems: [{ text: 'Directory', icon: <PeopleAltOutlinedIcon />, link: '/people' }],
    },
    {
        id: 'platform-users',
        featureName: 'platformUser_mgmt',
        permission: 'view',
        routes: [{ path: '/users', element: <Users /> }],
        sidebarItems: [{ text: 'Farm Users', icon: <FaUsers />, link: '/users' }],
    },
    {
        id: '360-users',
        featureName: 'user_mgmt',
        permission: 'view',
        routes: [{ path: '/user-management', element: <UserManagement /> }],
        sidebarItems: [{ text: '360 Users', icon: <FaRegUserCircle />, link: '/user-management' }],
    },
];

export default peopleManifests;
